import React from "react";

export default function Spinner() {
   return (
    <div class="spinner-border custom-spinner" role="status">
    <span class="sr-only">Loading...</span>
 </div>
   );
}
